import React from 'react';
import { List, Tooltip, Button, Divider } from 'antd';
import { CloseCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { isGuid } from '../../shared/utils';

const SelectedFilesList = ({ selectedFiles = [], onRemoveFile, onClearFiles, rootContainer, masterCertificateId, receiptId }) => {
  const filteredFiles = selectedFiles.filter((f) => f.id !== receiptId);

  if (!selectedFiles.length) return null;

  return (
    <>
      <List
        size="small"
        header={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>Selected files:</span>
            {filteredFiles.length ? (
              <div>
                {isGuid(masterCertificateId) && (
                  <a style={{ marginRight: '15px' }}>
                    <Tooltip
                      getTooltipContainer={rootContainer}
                      title="These files will be attached to currently selected Master Certificate and will be automatically selected on next certificate send."
                    >
                      <InfoCircleOutlined />
                    </Tooltip>
                  </a>
                )}
                <Button type="primary" size="small" ghost onClick={onClearFiles}>
                  Clear
                </Button>
              </div>
            ) : null}
          </div>
        }
        pagination={{
          size: 'small',
          showSizeChanger: true,
          showQuickJumper: true,
          defaultPageSize: 5,
          total: selectedFiles.length,
          pageSizeOptions: [5, 10, 20, 50],
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} files`,
        }}
        dataSource={selectedFiles}
        renderItem={(item) => (
          <List.Item>
            <div>{item.name}</div>
            <Tooltip title="Remove" getTooltipContainer={rootContainer}>
              <a onClick={() => onRemoveFile(item)}>
                <CloseCircleOutlined />
              </a>
            </Tooltip>
          </List.Item>
        )}
      />
    </>
  );
};

export default SelectedFilesList;
